import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./UserProfileSkeleton.module.scss";
import SocialPostSkeleton from "components/SocialPostComponent/SocialPostSkeleton";

const UserProfileSkeleton = () => {
  return (
    <section className={styles.UserProfileSkeleton}>
      <div className={styles.leftPanel}>
        <div className={styles.profileDetails}>
          <div className={styles.avatar}>
            <Skeleton circle height="100%" width="100%" />
          </div>
          <div className={styles.username}>
            <Skeleton height={12} />
          </div>
          <div className={styles.userTag}>
            <Skeleton height={8} />
          </div>
          <div className={styles.btnSection}>
            <div className={styles.button}>
              <Skeleton height={30} />
            </div>
            <div className={styles.button}>
              <Skeleton height={30} />
            </div>
          </div>
          <div className={styles.bio}>
            <Skeleton height={60} />
          </div>
        </div>
        <div className={styles.skillSection}>
          <div className={styles.skillTitle}>
            <Skeleton height={20} />
          </div>
          <div className={styles.skillArray}>
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className={styles.skillItem}>
                <Skeleton height={40} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.rightPanel}>
        <div className={styles.heading}>
          <Skeleton height={40} />
        </div>
        <SocialPostSkeleton count={4} />
      </div>
    </section>
  );
};

export default UserProfileSkeleton;
